import React from "react";

import { DownloadFilledIcon } from "@/Components/Icons/DownloadFilledIcon";
import { DownloadIcon } from "@/Components/Icons/DownloadIcon";

import CandidateFilledIcon from "./CandidateFilledIcon";
import CandidateIcon from "./CandidateIcon";
import QrCodeFilledIcon from "./QrCodeFilledIcon";
import QrCodeIcon from "./QrCodeIcon";
import UserAccessIcon from "./UserAccessIcon";

const SidebarIcons = ({ type = "dashboard" }) => {
  const obj = {
    dashboardActive: (
      <>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33327 2H7.83323C9.67414 2 11.1665 3.49236 11.1665 5.33327V7.83323C11.1665 9.67414 9.67414 11.1665 7.83323 11.1665H5.33327C3.49236 11.1665 2 9.67418 2 7.83323V5.33327C2 3.49236 3.49236 2 5.33327 2Z"
            fill="currentColor"
          />
          <path
            d="M16.1653 2H18.6653C20.5062 2 21.9985 3.49236 21.9985 5.33327V7.83323C21.9985 9.67414 20.5062 11.1665 18.6653 11.1665H16.1653C14.3244 11.1665 12.832 9.67414 12.832 7.83323V5.33327C12.832 3.49236 14.3244 2 16.1653 2Z"
            fill="currentColor"
          />
          <path
            d="M5.33327 12.833H7.83323C9.67414 12.833 11.1665 14.3254 11.1665 16.1663V18.6662C11.1665 20.5071 9.67414 21.9995 7.83323 21.9995H5.33327C3.49236 21.9995 2 20.5072 2 18.6663V16.1663C2 14.3254 3.49236 12.833 5.33327 12.833Z"
            fill="currentColor"
          />
          <path
            d="M16.1653 12.833H18.6653C20.5062 12.833 21.9985 14.3254 21.9985 16.1663V18.6662C21.9985 20.5072 20.5062 21.9995 18.6653 21.9995H16.1653C14.3244 21.9995 12.832 20.5072 12.832 18.6663V16.1663C12.832 14.3254 14.3244 12.833 16.1653 12.833Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    dashboard: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33327 10.1665H5.33325C4.04465 10.1665 3 9.12191 3 7.83323V5.33327C3 4.04464 4.04464 3 5.33327 3H7.83323C9.12185 3 10.1665 4.04464 10.1665 5.33327V7.83323C10.1665 9.12185 9.12185 10.1665 7.83323 10.1665H5.33327Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M13.832 5.33327V5.33325C13.832 4.04465 14.8766 3 16.1653 3H18.6653C19.9539 3 20.9985 4.04464 20.9985 5.33327V7.83323C20.9985 9.12185 19.9539 10.1665 18.6653 10.1665H16.1653C14.8767 10.1665 13.832 9.12185 13.832 7.83323V5.33327Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M5.33327 20.9995H5.33325C4.04464 20.9995 3 19.9549 3 18.6663V16.1663C3 14.8776 4.04465 13.833 5.33327 13.833H7.83323C9.12185 13.833 10.1665 14.8777 10.1665 16.1663V18.6662C10.1665 19.9549 9.12185 20.9995 7.83323 20.9995H5.33327Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M13.832 16.1663V16.1663C13.832 14.8777 14.8766 13.833 16.1653 13.833H18.6653C19.9539 13.833 20.9985 14.8777 20.9985 16.1663V18.6662C20.9985 19.9549 19.9539 20.9995 18.6653 20.9995H16.1653C14.8767 20.9995 13.832 19.9549 13.832 18.6663V16.1663Z"
          fill="white"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
    postJobActive: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.8333 5.33333H16.9167C16.7233 4.39284 16.2115 3.54779 15.4677 2.9406C14.7239 2.33341 13.7935 2.00121 12.8333 2L11.1667 2C10.2065 2.00121 9.2761 2.33341 8.53229 2.9406C7.78848 3.54779 7.27675 4.39284 7.08333 5.33333H6.16667C5.062 5.33466 4.00296 5.77407 3.22185 6.55518C2.44073 7.3363 2.00132 8.39534 2 9.5L2 12H22V9.5C21.9987 8.39534 21.5593 7.3363 20.7782 6.55518C19.997 5.77407 18.938 5.33466 17.8333 5.33333ZM8.82 5.33333C8.99174 4.84758 9.30936 4.42674 9.72942 4.12841C10.1495 3.83007 10.6514 3.6688 11.1667 3.66667H12.8333C13.3485 3.6688 13.8505 3.83007 14.2706 4.12841C14.6906 4.42674 15.0083 4.84758 15.18 5.33333H8.82Z"
          fill="currentColor"
        />
        <path
          d="M12.8333 14.8C12.8333 15.0122 12.7455 15.2157 12.5893 15.3657C12.433 15.5157 12.221 15.6 12 15.6C11.779 15.6 11.567 15.5157 11.4107 15.3657C11.2545 15.2157 11.1667 15.0122 11.1667 14.8V14H2V18C2.00132 19.0605 2.44073 20.0772 3.22185 20.827C4.00296 21.5769 5.062 21.9987 6.16667 22H17.8333C18.938 21.9987 19.997 21.5769 20.7782 20.827C21.5593 20.0772 21.9987 19.0605 22 18V14H12.8333V14.8Z"
          fill="currentColor"
        />
      </svg>
    ),
    postJob: (
      <>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.8333 5.83333H16.9167C16.7233 4.89284 16.2115 4.04779 15.4677 3.4406C14.7239 2.83341 13.7935 2.50121 12.8333 2.5L11.1667 2.5C10.2065 2.50121 9.2761 2.83341 8.53229 3.4406C7.78848 4.04779 7.27675 4.89284 7.08333 5.83333H6.16667C5.062 5.83466 4.00296 6.27407 3.22185 7.05518C2.44073 7.8363 2.00132 8.89534 2 10L2 18.3333C2.00132 19.438 2.44073 20.497 3.22185 21.2782C4.00296 22.0593 5.062 22.4987 6.16667 22.5H17.8333C18.938 22.4987 19.997 22.0593 20.7782 21.2782C21.5593 20.497 21.9987 19.438 22 18.3333V10C21.9987 8.89534 21.5593 7.8363 20.7782 7.05518C19.997 6.27407 18.938 5.83466 17.8333 5.83333ZM11.1667 4.16667H12.8333C13.3485 4.1688 13.8505 4.33007 14.2706 4.62841C14.6906 4.92674 15.0083 5.34758 15.18 5.83333H8.82C8.99174 5.34758 9.30936 4.92674 9.72942 4.62841C10.1495 4.33007 10.6514 4.1688 11.1667 4.16667ZM6.16667 7.5H17.8333C18.4964 7.5 19.1323 7.76339 19.6011 8.23223C20.0699 8.70107 20.3333 9.33696 20.3333 10V12.5H3.66667V10C3.66667 9.33696 3.93006 8.70107 4.3989 8.23223C4.86774 7.76339 5.50363 7.5 6.16667 7.5ZM17.8333 20.8333H6.16667C5.50363 20.8333 4.86774 20.5699 4.3989 20.1011C3.93006 19.6323 3.66667 18.9964 3.66667 18.3333V14.1667H11.1667V15C11.1667 15.221 11.2545 15.433 11.4107 15.5893C11.567 15.7455 11.779 15.8333 12 15.8333C12.221 15.8333 12.433 15.7455 12.5893 15.5893C12.7455 15.433 12.8333 15.221 12.8333 15V14.1667H20.3333V18.3333C20.3333 18.9964 20.0699 19.6323 19.6011 20.1011C19.1323 20.5699 18.4964 20.8333 17.8333 20.8333Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    scheduleActive: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 7.83333V8.66667H2V7.83333C2 5.5325 3.86583 3.66667 6.16667 3.66667H7V2.83333C7 2.37333 7.37333 2 7.83333 2C8.29333 2 8.66667 2.37333 8.66667 2.83333V3.66667H15.3333V2.83333C15.3333 2.37333 15.7067 2 16.1667 2C16.6267 2 17 2.37333 17 2.83333V3.66667H17.8333C20.1342 3.66667 22 5.5325 22 7.83333ZM22 16.1667C22 19.3833 19.3825 22 16.1667 22C12.9508 22 10.3333 19.3833 10.3333 16.1667C10.3333 12.95 12.9508 10.3333 16.1667 10.3333C19.3825 10.3333 22 12.95 22 16.1667ZM17.8333 16.655L17 15.8217V14.5C17 14.04 16.6267 13.6667 16.1667 13.6667C15.7067 13.6667 15.3333 14.04 15.3333 14.5V16.1667C15.3333 16.3875 15.4208 16.6 15.5775 16.7558L16.655 17.8333C16.98 18.1583 17.5083 18.1583 17.8333 17.8333C18.1583 17.5083 18.1583 16.98 17.8333 16.655ZM8.66667 16.1667C8.66667 13.8092 9.75667 11.7083 11.4575 10.3333H2V17.8333C2 20.1342 3.86583 22 6.16667 22H11.4575C9.75667 20.625 8.66667 18.5242 8.66667 16.1667Z"
          fill="currentColor"
        />
      </svg>
    ),
    schedule: (
      <>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1667 10.3658C12.9508 10.3658 10.3333 12.9825 10.3333 16.1992C10.3333 19.3975 12.9508 22 16.1667 22C19.3825 22 22 19.3833 22 16.1667C22 12.9683 19.3825 10.3658 16.1667 10.3658ZM16.1667 20.3333C13.8692 20.3333 12 18.4783 12 16.1992C12 13.9017 13.8692 12.0325 16.1667 12.0325C18.4642 12.0325 20.3333 13.8875 20.3333 16.1667C20.3333 18.4642 18.4642 20.3333 16.1667 20.3333ZM17.5892 16.4108C17.915 16.7367 17.915 17.2633 17.5892 17.5892C17.4267 17.7517 17.2133 17.8333 17 17.8333C16.7867 17.8333 16.5733 17.7517 16.4108 17.5892L15.5775 16.7558C15.4208 16.5992 15.3333 16.3875 15.3333 16.1667V14.5C15.3333 14.04 15.7058 13.6667 16.1667 13.6667C16.6275 13.6667 17 14.04 17 14.5V15.8217L17.5892 16.4108ZM22 7.83333V9.5C22 9.96 21.6275 10.3333 21.1667 10.3333C20.7058 10.3333 20.3333 9.96 20.3333 9.5V7.83333C20.3333 6.455 19.2117 5.33333 17.8333 5.33333H6.16667C4.78833 5.33333 3.66667 6.455 3.66667 7.83333V8.66667H11.1667C11.6267 8.66667 12 9.04 12 9.5C12 9.96 11.6267 10.3333 11.1667 10.3333H3.66667V17.8333C3.66667 19.2117 4.78833 20.3333 6.16667 20.3333H9.5C9.96 20.3333 10.3333 20.7067 10.3333 21.1667C10.3333 21.6267 9.96 22 9.5 22H6.16667C3.86917 22 2 20.1308 2 17.8333V7.83333C2 5.53583 3.86917 3.66667 6.16667 3.66667H7V2.83333C7 2.37333 7.37333 2 7.83333 2C8.29333 2 8.66667 2.37333 8.66667 2.83333V3.66667H15.3333V2.83333C15.3333 2.37333 15.7058 2 16.1667 2C16.6275 2 17 2.37333 17 2.83333V3.66667H17.8333C20.1308 3.66667 22 5.53583 22 7.83333Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    candidatesActive: (
      <>
        <CandidateFilledIcon />
      </>
    ),
    candidates: (
      <>
        <CandidateIcon />
      </>
    ),
    clientusersActive: (
      <>
        <CandidateFilledIcon />
      </>
    ),
    clientusers: (
      <>
        <CandidateIcon />
      </>
    ),
    clientUserAccess: (
      <>
        <UserAccessIcon cls={"w-[20px] h-[21px]"} />
      </>
    ),
    timesheetsActive: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2 7.83333V2.38333C14.9863 2.67445 15.7005 3.12609 16.2953 3.70833L19.2566 6.61333C19.8512 7.19573 20.3122 7.89575 20.609 8.66667H15.05C14.8246 8.66667 14.6084 8.57887 14.449 8.42259C14.2896 8.26631 14.2 8.05435 14.2 7.83333ZM21 10.7375V17.8333C20.9987 18.938 20.5505 19.997 19.7537 20.7782C18.957 21.5593 17.8768 21.9987 16.75 22H8.25C7.12324 21.9987 6.04302 21.5593 5.24629 20.7782C4.44955 19.997 4.00135 18.938 4 17.8333V6.16667C4.00135 5.062 4.44955 4.00296 5.24629 3.22185C6.04302 2.44073 7.12324 2.00132 8.25 2L12.0878 2C12.2263 2 12.3632 2.01083 12.5 2.02V7.83333C12.5 8.49637 12.7687 9.13226 13.2469 9.6011C13.7251 10.0699 14.3737 10.3333 15.05 10.3333H20.9796C20.989 10.4675 21 10.6017 21 10.7375ZM14.2 17.8333C14.2 17.6123 14.1104 17.4004 13.951 17.2441C13.7916 17.0878 13.5754 17 13.35 17H9.1C8.87457 17 8.65837 17.0878 8.49896 17.2441C8.33955 17.4004 8.25 17.6123 8.25 17.8333C8.25 18.0543 8.33955 18.2663 8.49896 18.4226C8.65837 18.5789 8.87457 18.6667 9.1 18.6667H13.35C13.5754 18.6667 13.7916 18.5789 13.951 18.4226C14.1104 18.2663 14.2 18.0543 14.2 17.8333ZM16.75 14.5C16.75 14.279 16.6604 14.067 16.501 13.9107C16.3416 13.7545 16.1254 13.6667 15.9 13.6667H9.1C8.87457 13.6667 8.65837 13.7545 8.49896 13.9107C8.33955 14.067 8.25 14.279 8.25 14.5C8.25 14.721 8.33955 14.933 8.49896 15.0893C8.65837 15.2455 8.87457 15.3333 9.1 15.3333H15.9C16.1254 15.3333 16.3416 15.2455 16.501 15.0893C16.6604 14.933 16.75 14.721 16.75 14.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    timesheets: (
      <>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.75 14.1667C16.75 14.3877 16.6604 14.5996 16.501 14.7559C16.3416 14.9122 16.1254 15 15.9 15H9.09999C8.87456 15 8.65836 14.9122 8.49895 14.7559C8.33955 14.5996 8.24999 14.3877 8.24999 14.1667C8.24999 13.9457 8.33955 13.7337 8.49895 13.5774C8.65836 13.4211 8.87456 13.3333 9.09999 13.3333H15.9C16.1254 13.3333 16.3416 13.4211 16.501 13.5774C16.6604 13.7337 16.75 13.9457 16.75 14.1667ZM13.35 16.6667H9.09999C8.87456 16.6667 8.65836 16.7545 8.49895 16.9107C8.33955 17.067 8.24999 17.279 8.24999 17.5C8.24999 17.721 8.33955 17.933 8.49895 18.0893C8.65836 18.2455 8.87456 18.3333 9.09999 18.3333H13.35C13.5754 18.3333 13.7916 18.2455 13.951 18.0893C14.1104 17.933 14.2 17.721 14.2 17.5C14.2 17.279 14.1104 17.067 13.951 16.9107C13.7916 16.7545 13.5754 16.6667 13.35 16.6667ZM21 11.2375V18.3333C20.9986 19.438 20.5504 20.497 19.7537 21.2782C18.957 22.0593 17.8767 22.4987 16.75 22.5H8.24999C7.12324 22.4987 6.04302 22.0593 5.24629 21.2782C4.44955 20.497 4.00135 19.438 4 18.3333V6.66668C4.00135 5.56202 4.44955 4.50298 5.24629 3.72187C6.04302 2.94075 7.12324 2.50134 8.24999 2.50002H12.0877C12.8694 2.49805 13.6437 2.64801 14.3659 2.94123C15.0881 3.23446 15.7439 3.66513 16.2952 4.20835L19.2566 7.11335C19.811 7.65355 20.2506 8.29623 20.5498 9.00416C20.8491 9.71209 21.0021 10.4712 21 11.2375ZM15.0933 5.38668C14.8258 5.13265 14.5255 4.91412 14.2 4.73668V8.33335C14.2 8.55436 14.2895 8.76632 14.4489 8.9226C14.6084 9.07888 14.8246 9.16668 15.05 9.16668H18.7186C18.5375 8.84767 18.3143 8.55347 18.0547 8.29168L15.0933 5.38668ZM19.3 11.2375C19.3 11.1 19.2728 10.9683 19.26 10.8333H15.05C14.3737 10.8333 13.7251 10.57 13.2469 10.1011C12.7686 9.63227 12.5 8.99639 12.5 8.33335V4.20585C12.3623 4.19335 12.2271 4.16668 12.0877 4.16668H8.24999C7.57369 4.16668 6.92509 4.43008 6.44687 4.89892C5.96866 5.36776 5.7 6.00364 5.7 6.66668V18.3333C5.7 18.9964 5.96866 19.6323 6.44687 20.1011C6.92509 20.5699 7.57369 20.8333 8.24999 20.8333H16.75C17.4263 20.8333 18.0749 20.5699 18.5531 20.1011C19.0313 19.6323 19.3 18.9964 19.3 18.3333V11.2375Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    invoicesActive: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2 7.83333V2.38333C14.9863 2.67445 15.7005 3.12609 16.2953 3.70833L19.2566 6.61333C19.8512 7.19573 20.3122 7.89575 20.609 8.66667H15.05C14.8246 8.66667 14.6084 8.57887 14.449 8.42259C14.2896 8.26631 14.2 8.05435 14.2 7.83333ZM21 10.7375V17.8333C20.9987 18.938 20.5505 19.997 19.7537 20.7782C18.957 21.5593 17.8768 21.9987 16.75 22H8.25C7.12324 21.9987 6.04302 21.5593 5.24629 20.7782C4.44955 19.997 4.00135 18.938 4 17.8333V6.16667C4.00135 5.062 4.44955 4.00296 5.24629 3.22185C6.04302 2.44073 7.12324 2.00132 8.25 2L12.0878 2C12.2263 2 12.3632 2.01083 12.5 2.02V7.83333C12.5 8.49637 12.7687 9.13226 13.2469 9.6011C13.7251 10.0699 14.3737 10.3333 15.05 10.3333H20.9796C20.989 10.4675 21 10.6017 21 10.7375ZM15.9 16.1667C15.9 15.9457 15.8104 15.7337 15.651 15.5774C15.4916 15.4211 15.2754 15.3333 15.05 15.3333H13.35V13.6667C13.35 13.4457 13.2604 13.2337 13.101 13.0774C12.9416 12.9211 12.7254 12.8333 12.5 12.8333C12.2746 12.8333 12.0584 12.9211 11.899 13.0774C11.7396 13.2337 11.65 13.4457 11.65 13.6667V15.3333H9.95C9.72457 15.3333 9.50837 15.4211 9.34896 15.5774C9.18955 15.7337 9.1 15.9457 9.1 16.1667C9.1 16.3877 9.18955 16.5996 9.34896 16.7559C9.50837 16.9122 9.72457 17 9.95 17H11.65V18.6667C11.65 18.8877 11.7396 19.0996 11.899 19.2559C12.0584 19.4122 12.2746 19.5 12.5 19.5C12.7254 19.5 12.9416 19.4122 13.101 19.2559C13.2604 19.0996 13.35 18.8877 13.35 18.6667V17H15.05C15.2754 17 15.4916 16.9122 15.651 16.7559C15.8104 16.5996 15.9 16.3877 15.9 16.1667Z"
          fill="currentColor"
        />
      </svg>
    ),
    invoices: (
      <>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9 15.8333C15.9 16.0544 15.8104 16.2663 15.651 16.4226C15.4916 16.5789 15.2754 16.6667 15.05 16.6667H13.35V18.3333C13.35 18.5543 13.2604 18.7663 13.101 18.9226C12.9416 19.0789 12.7254 19.1667 12.5 19.1667C12.2746 19.1667 12.0584 19.0789 11.8989 18.9226C11.7395 18.7663 11.65 18.5543 11.65 18.3333V16.6667H9.94999C9.72456 16.6667 9.50836 16.5789 9.34895 16.4226C9.18955 16.2663 9.09999 16.0544 9.09999 15.8333C9.09999 15.6123 9.18955 15.4004 9.34895 15.2441C9.50836 15.0878 9.72456 15 9.94999 15H11.65V13.3333C11.65 13.1123 11.7395 12.9004 11.8989 12.7441C12.0584 12.5878 12.2746 12.5 12.5 12.5C12.7254 12.5 12.9416 12.5878 13.101 12.7441C13.2604 12.9004 13.35 13.1123 13.35 13.3333V15H15.05C15.2754 15 15.4916 15.0878 15.651 15.2441C15.8104 15.4004 15.9 15.6123 15.9 15.8333ZM21 11.2375V18.3333C20.9986 19.438 20.5504 20.497 19.7537 21.2782C18.957 22.0593 17.8767 22.4987 16.75 22.5H8.24999C7.12324 22.4987 6.04302 22.0593 5.24629 21.2782C4.44955 20.497 4.00135 19.438 4 18.3333V6.66668C4.00135 5.56202 4.44955 4.50298 5.24629 3.72187C6.04302 2.94075 7.12324 2.50134 8.24999 2.50002H12.0877C12.8694 2.49805 13.6437 2.64801 14.3659 2.94123C15.0881 3.23446 15.7439 3.66513 16.2952 4.20835L19.2566 7.11335C19.811 7.65355 20.2506 8.29623 20.5498 9.00416C20.8491 9.71209 21.0021 10.4712 21 11.2375ZM15.0933 5.38668C14.8258 5.13265 14.5255 4.91412 14.2 4.73668V8.33335C14.2 8.55436 14.2895 8.76632 14.4489 8.9226C14.6084 9.07888 14.8246 9.16668 15.05 9.16668H18.7186C18.5375 8.84767 18.3143 8.55347 18.0547 8.29168L15.0933 5.38668ZM19.3 11.2375C19.3 11.1 19.2728 10.9683 19.26 10.8333H15.05C14.3737 10.8333 13.7251 10.57 13.2469 10.1011C12.7686 9.63227 12.5 8.99639 12.5 8.33335V4.20585C12.3623 4.19335 12.2271 4.16668 12.0877 4.16668H8.24999C7.57369 4.16668 6.92509 4.43008 6.44687 4.89892C5.96866 5.36776 5.7 6.00364 5.7 6.66668V18.3333C5.7 18.9964 5.96866 19.6323 6.44687 20.1011C6.92509 20.5699 7.57369 20.8333 8.24999 20.8333H16.75C17.4263 20.8333 18.0749 20.5699 18.5531 20.1011C19.0313 19.6323 19.3 18.9964 19.3 18.3333V11.2375Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    billingActive: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4167 4H5.58333C4.3682 4.00159 3.20326 4.52888 2.34403 5.46622C1.48481 6.40356 1.00146 7.67441 1 9H23C22.9985 7.67441 22.5152 6.40356 21.656 5.46622C20.7967 4.52888 19.6318 4.00159 18.4167 4Z"
          fill="currentColor"
        />
        <path
          d="M1 16.4545C1.00146 17.6596 1.48481 18.8149 2.34403 19.6671C3.20326 20.5192 4.3682 20.9986 5.58333 21H18.4167C19.6318 20.9986 20.7967 20.5192 21.656 19.6671C22.5152 18.8149 22.9985 17.6596 23 16.4545V11H1V16.4545ZM7.41667 16C7.41667 16.2697 7.33602 16.5333 7.18494 16.7576C7.03385 16.9818 6.81911 17.1566 6.56786 17.2598C6.31661 17.363 6.04014 17.3901 5.77342 17.3374C5.50669 17.2848 5.26169 17.1549 5.06939 16.9642C4.8771 16.7735 4.74614 16.5306 4.69309 16.266C4.64003 16.0015 4.66726 15.7273 4.77133 15.4782C4.8754 15.229 5.05164 15.016 5.27776 14.8662C5.50388 14.7163 5.76972 14.6364 6.04167 14.6364C6.40634 14.6364 6.75608 14.78 7.01394 15.0358C7.2718 15.2915 7.41667 15.6383 7.41667 16Z"
          fill="currentColor"
        />
      </svg>
    ),
    billing: (
      <>
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 17.5C6.32843 17.5 7 16.8284 7 16C7 15.1716 6.32843 14.5 5.5 14.5C4.67157 14.5 4 15.1716 4 16C4 16.8284 4.67157 17.5 5.5 17.5Z"
            fill="currentColor"
          />
          <path
            d="M18.4167 4.5H5.58333C4.3682 4.5015 3.20326 4.9995 2.34403 5.88476C1.48481 6.77003 1.00146 7.97027 1 9.22222L1 16.7778C1.00146 18.0297 1.48481 19.23 2.34403 20.1152C3.20326 21.0005 4.3682 21.4985 5.58333 21.5H18.4167C19.6318 21.4985 20.7967 21.0005 21.656 20.1152C22.5152 19.23 22.9985 18.0297 23 16.7778V9.22222C22.9985 7.97027 22.5152 6.77003 21.656 5.88476C20.7967 4.9995 19.6318 4.5015 18.4167 4.5ZM5.58333 6.38889H18.4167C19.146 6.38889 19.8455 6.6874 20.3612 7.21875C20.8769 7.75011 21.1667 8.47078 21.1667 9.22222H2.83333C2.83333 8.47078 3.12306 7.75011 3.63879 7.21875C4.15452 6.6874 4.85399 6.38889 5.58333 6.38889ZM18.4167 19.6111H5.58333C4.85399 19.6111 4.15452 19.3126 3.63879 18.7812C3.12306 18.2499 2.83333 17.5292 2.83333 16.7778V11.1111H21.1667V16.7778C21.1667 17.5292 20.8769 18.2499 20.3612 18.7812C19.8455 19.3126 19.146 19.6111 18.4167 19.6111Z"
            fill="currentColor"
          />
        </svg>
      </>
    ),
    termsConditionActive: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M18 2.5H6C5.20435 2.5 4.44129 2.81607 3.87868 3.37868C3.31607 3.94129 3 4.70435 3 5.5V19.5C3 20.2956 3.31607 21.0587 3.87868 21.6213C4.44129 22.1839 5.20435 22.5 6 22.5H18C18.7956 22.5 19.5587 22.1839 20.1213 21.6213C20.6839 21.0587 21 20.2956 21 19.5V5.5C21 4.70435 20.6839 3.94129 20.1213 3.37868C19.5587 2.81607 18.7956 2.5 18 2.5ZM8 6H12C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7C13 7.26522 12.8946 7.51957 12.7071 7.70711C12.5196 7.89464 12.2652 8 12 8H8C7.73478 8 7.48043 7.89464 7.29289 7.70711C7.10536 7.51957 7 7.26522 7 7C7 6.73478 7.10536 6.48043 7.29289 6.29289C7.48043 6.10536 7.73478 6 8 6ZM16 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18C7 17.7348 7.10536 17.4804 7.29289 17.2929C7.48043 17.1054 7.73478 17 8 17H16C16.2652 17 16.5196 17.1054 16.7071 17.2929C16.8946 17.4804 17 17.7348 17 18C17 18.2652 16.8946 18.5196 16.7071 18.7071C16.5196 18.8946 16.2652 19 16 19ZM16 15.33H8C7.73478 15.33 7.48043 15.2246 7.29289 15.0371C7.10536 14.8496 7 14.5952 7 14.33C7 14.0648 7.10536 13.8104 7.29289 13.6229C7.48043 13.4354 7.73478 13.33 8 13.33H16C16.2652 13.33 16.5196 13.4354 16.7071 13.6229C16.8946 13.8104 17 14.0648 17 14.33C17 14.5952 16.8946 14.8496 16.7071 15.0371C16.5196 15.2246 16.2652 15.33 16 15.33ZM16 11.67H8C7.73478 11.67 7.48043 11.5646 7.29289 11.3771C7.10536 11.1896 7 10.9352 7 10.67C7 10.4048 7.10536 10.1504 7.29289 9.96289C7.48043 9.77536 7.73478 9.67 8 9.67H16C16.2652 9.67 16.5196 9.77536 16.7071 9.96289C16.8946 10.1504 17 10.4048 17 10.67C17 10.9352 16.8946 11.1896 16.7071 11.3771C16.5196 11.5646 16.2652 11.67 16 11.67Z"
            fill="#2843DF"
          />
        </svg>
      </>
    ),
    termsCondition: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M18 22.5H6C5.20435 22.5 4.44129 22.1839 3.87868 21.6213C3.31607 21.0587 3 20.2956 3 19.5V5.5C3 4.70435 3.31607 3.94129 3.87868 3.37868C4.44129 2.81607 5.20435 2.5 6 2.5H18C18.7956 2.5 19.5587 2.81607 20.1213 3.37868C20.6839 3.94129 21 4.70435 21 5.5V19.5C21 20.2956 20.6839 21.0587 20.1213 21.6213C19.5587 22.1839 18.7956 22.5 18 22.5ZM6 4.5C5.73478 4.5 5.48043 4.60536 5.29289 4.79289C5.10536 4.98043 5 5.23478 5 5.5V19.5C5 19.7652 5.10536 20.0196 5.29289 20.2071C5.48043 20.3946 5.73478 20.5 6 20.5H18C18.2652 20.5 18.5196 20.3946 18.7071 20.2071C18.8946 20.0196 19 19.7652 19 19.5V5.5C19 5.23478 18.8946 4.98043 18.7071 4.79289C18.5196 4.60536 18.2652 4.5 18 4.5H6Z"
            fill="#6A6E73"
          />
          <path
            d="M12 8H8C7.73478 8 7.48043 7.89464 7.29289 7.70711C7.10536 7.51957 7 7.26522 7 7C7 6.73478 7.10536 6.48043 7.29289 6.29289C7.48043 6.10536 7.73478 6 8 6H12C12.2652 6 12.5196 6.10536 12.7071 6.29289C12.8946 6.48043 13 6.73478 13 7C13 7.26522 12.8946 7.51957 12.7071 7.70711C12.5196 7.89464 12.2652 8 12 8Z"
            fill="#6A6E73"
          />
          <path
            d="M16 11.6699H8C7.73478 11.6699 7.48043 11.5646 7.29289 11.377C7.10536 11.1895 7 10.9351 7 10.6699C7 10.4047 7.10536 10.1504 7.29289 9.96282C7.48043 9.77528 7.73478 9.66992 8 9.66992H16C16.2652 9.66992 16.5196 9.77528 16.7071 9.96282C16.8946 10.1504 17 10.4047 17 10.6699C17 10.9351 16.8946 11.1895 16.7071 11.377C16.5196 11.5646 16.2652 11.6699 16 11.6699Z"
            fill="#6A6E73"
          />
          <path
            d="M16 15.3301H8C7.73478 15.3301 7.48043 15.2247 7.29289 15.0372C7.10536 14.8496 7 14.5953 7 14.3301C7 14.0649 7.10536 13.8105 7.29289 13.623C7.48043 13.4354 7.73478 13.3301 8 13.3301H16C16.2652 13.3301 16.5196 13.4354 16.7071 13.623C16.8946 13.8105 17 14.0649 17 14.3301C17 14.5953 16.8946 14.8496 16.7071 15.0372C16.5196 15.2247 16.2652 15.3301 16 15.3301Z"
            fill="#6A6E73"
          />
          <path
            d="M16 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18C7 17.7348 7.10536 17.4804 7.29289 17.2929C7.48043 17.1054 7.73478 17 8 17H16C16.2652 17 16.5196 17.1054 16.7071 17.2929C16.8946 17.4804 17 17.7348 17 18C17 18.2652 16.8946 18.5196 16.7071 18.7071C16.5196 18.8946 16.2652 19 16 19Z"
            fill="#6A6E73"
          />
        </svg>
      </>
    ),
    qrCode: (
      <>
        <div className="grid h-[25px] w-[24px] place-items-center">
          <QrCodeIcon cls="w-[18px]" />
        </div>
      </>
    ),
    qrCodeActive: (
      <>
        <QrCodeFilledIcon />
      </>
    ),
    downloads: <DownloadIcon />,
    downloadsActive: <DownloadFilledIcon />,
  };

  return obj[type] ? obj[type] : null;
};

export default SidebarIcons;
